module.exports = __webpack_public_path__ + "img/Slideshow BV EC 1.62346591.png";